import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, of, switchMap } from "rxjs";
import { raceActions } from "src/app/core/store/race/race.actions";
import { RaceService } from "../../services/race.service";

@Injectable()
export class RaceEffect {

    private readonly action$ = inject(Actions);
    private readonly raceService = inject(RaceService);


    loadRaceFromApi$ = createEffect(() => {
        return this.action$.pipe(
            ofType(raceActions.loadRace),
            switchMap((payload) => this.raceService.getRaces(payload.payload).pipe(
                map(raceResponse => raceActions.loadSuccess(raceResponse)),
                catchError((raceResponse) => of(raceActions.loadFailed(raceResponse)))
            ))
        )
    })

    loadRaceByIdFromApi$ = createEffect(() => {
        return this.action$.pipe(
            ofType(raceActions.loadRaceById),
            switchMap((payload) => this.raceService.getRaceById(payload.payload.id as any).pipe(
                map(raceResponse => raceActions.loadByIdSuccess(raceResponse)),
                catchError((raceResponse) => of(raceActions.loadByIdFailed(raceResponse)))
            ))
        )
    })
}